import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { fromEvent } from 'rxjs';

/** Abstracts DOM events emitted by legacy MCRC API with rxjs Observables */
@Injectable()
export class McRcEventsService {

    // Emits whenever server would like to stop recording due to server-related event or error
    // IMPORTANT: does not emit whenever recording is stopped upon user's request
    public rcVideoRecordingStopped = fromEvent(this.document, 'rcVideoRecordingStopped');

    // Emits whenever server video recording has been started by Assist server (upon user request)
    public rcVideoRecordingStarted = fromEvent(this.document, 'rcVideoRecordingStarted');

    // Emits events from agent related to annotations
    public rcAnnotationMessage = fromEvent(this.document, 'rcAnnotationMessage');

    // Emits events from agent: whenever agent/with audio video recording has
    // been stopped by agent, usually due to recording limits reached.
    public rcAgentRecordingStopped = fromEvent(this.document, 'rcAgentRecordingStopped');

    // Emits events from agent: whenever agent video/audio recording finishes per user request
    public rcAgentRecordingStoppedByUser = fromEvent(this.document, 'rcAgentRecordingStoppedByUser');

    // Assist server remote control events (mostly used by by server-side video recording)
    public rcServerStatusUpdate = fromEvent(this.document, 'rcServerStatusUpdate');

    public rcDeviceLogsDownloadReady = fromEvent(this.document, 'rcDeviceLogsDownloadReady');

    constructor(@Inject(DOCUMENT) private document: Document) { }
}
